export const getErrorPayload = (error) => {
    if (!error || typeof error != 'object')
        return internalError;
    const axiosError = error;
    if (axiosError.response) {
        const data = axiosError.response.data;
        // If backend returns {message: "..."}, map it to error field for consistency
        return {
            ...data,
            error: data.error || data.message,
            status: axiosError.response.status
        };
    }
    else
        return internalError;
};
const internalError = {
    error: 'Internal error occured during request.',
    status: 500
};
